export enum ApiVersions {
  /**
   * Beta API version
   */
  Beta = 'beta',
  /**
   * @deprecated V0 (20160426) is deprecated. Use V4 instead.
   */
  V0 = '20160426',
  /**
   * @deprecated V1 (20191212) is deprecated. Use V4 instead.
   */
  V1 = '20191212',
  /**
   * @deprecated V2 (20210729) is deprecated. Use V4 instead.
   */
  V2 = '20210729',
  /**
   * @deprecated V3 (20220603) is deprecated. Use V4 instead.
   */
  V3 = '20220603',
  /**
   * Current API version (20240415) as of 01/09/2026
   */
  V4 = '20240415',
}

// Export the type as well for cases where undefined is needed
export type ApiVersionsOrUndefined = ApiVersions | undefined;
